<!--
  - Copyright (c) 2020. Minerva Networks.
  - All rights reserved.
  -->

<template lang="html">
  <section class="Onboarding" v-if="info">
    <div class="Onboarding__inner">
      <div class="Onboarding__inner__title">{{ info.title }}</div>
      <div class="Onboarding__inner__video">
        <div
          class="slide"
          :key="info.title"
        >
          <div class="slide__inner"
               :class="`ar16_9`"
          >
            <bkg :url="info.video.cover"></bkg>
            <div class="slide__inner__btn">
              <span>{{canSee({ offers: info.video.offers })}}</span>
              <highlightsBtn v-if="info.video.video_type == 'smart-highlights'" :id="info.video.video_id" :offers="info.video.offers" ga="Onboarding" size="80" ></highlightsBtn>
              <playBtn v-else :id="info.video.video_id" :offers="info.video.offers" :ga="Onboarding" ></playBtn>
            </div>
            <component class="videoType" :is="info.video.video_type"></component>
          </div>
          <div class="slide__title">
            {{ info.video.title }}
          </div>
        </div>
      </div>
      <h1 class="Onboarding__inner__description">{{ info.description }}</h1>
      <h1 class="Onboarding__inner__button"
          @click="playVideoById({
            id: info.video.video_id,
            offers: info.video.offers,
            router: $router,
            ga: 'Onboarding',
          });"
      >{{ info.action }}</h1>
    </div>
  </section>
</template>

<script lang="js">
import {
  mapState,
  mapMutations,
  mapGetters,
  mapActions,
} from 'vuex';
import md5 from 'md5';
import playBtn from './glyphs/PlayBtn.vue';
import highlightsBtn from './glyphs/HighlightsBtn.vue';
import live from './glyphs/Live.vue';
import smartHighlights from './glyphs/HighlightsBadge.vue';
import locked from './glyphs/LockedGlyph.vue';
import vod from './glyphs/Vod.vue';
import bkg from './Bkg.vue';

export default {
  name: 'Onboarding',
  props: [],
  components: {
    playBtn,
    highlightsBtn,
    live,
    smartHighlights,
    vod,
    locked,
    bkg,
  },
  data() {
    return {
      md5,
      info: false,
    };
  },
  mounted() {
    const that = this;
    this.api.get('/onboarding', {
      headers: {
        'x-tok-token': that.getToken(that.$ls, that.$router),
        'Accept-Language': that.locale,
      },
    })
      .then((response) => {
        that.info = response.data;
      })
      .catch(() => {
        that.$log.debug('Error while getting onboarding');
      });
  },
  methods: {
    ...mapActions(['playVideoById']),
    ...mapMutations(['appReady', 'canSee', 'redirectToIP']),
    getToken(ls) {
      const status = ls.get('storageAccessData');
      if (status && status.token) {
        return status.token;
      }
      this.redirectToIP({
        router: this.$router,
        registered: false,
      });
      return true;
    },
  },
  computed: {
    ...mapGetters(['scaleImage']),
    ...mapState(['api', 'locale', 'me']),
  },
};
</script>
